webpackJsonp([177401889866788],{

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageBlogueQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  padding: 40px;\n  margin-bottom: 20px;\n  &:last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  padding: 40px;\n  margin-bottom: 20px;\n  &:last-child {\n    margin-bottom: 0;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding-bottom: 10px;\n  h2 {\n    margin-bottom: 0;\n  }\n"], ["\n  padding-bottom: 10px;\n  h2 {\n    margin-bottom: 0;\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(79);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(115);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactHelmet = __webpack_require__(65);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SiteConfig = __webpack_require__(47);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _styledComponents = __webpack_require__(87);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _semanticUiReact = __webpack_require__(46);
	
	var _propTypes = __webpack_require__(1);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	/** Style **/
	
	
	var propTypes = {
	  data: PropTypes.object.isRequired
	};
	
	var ArticleItem = _styledComponents2.default.article(_templateObject);
	
	var Header = _styledComponents2.default.header(_templateObject2);
	
	var BloguePage = function (_React$Component) {
	  _inherits(BloguePage, _React$Component);
	
	  function BloguePage() {
	    _classCallCheck(this, BloguePage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BloguePage.prototype.render = function render() {
	    var frArticles = this.props.data.fr.edges;
	    var MetaTitle = function MetaTitle() {
	      return _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          "title",
	          null,
	          "Blogue | " + _SiteConfig2.default.siteTitle
	        )
	      );
	    };
	
	    var ARTICLE = function ARTICLE(_ref) {
	      var node = _ref.node;
	      return _react2.default.createElement(
	        ArticleItem,
	        {
	          role: "article",
	          itemscope: "itemscope",
	          itemtype: "http://schema.org/Article"
	        },
	        _react2.default.createElement(
	          Header,
	          null,
	          _react2.default.createElement(
	            "h2",
	            null,
	            node.title
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "typo__7" },
	            "Post\xE9 le ",
	            _react2.default.createElement(
	              "time",
	              null,
	              node.createdAt
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "figure",
	          null,
	          _react2.default.createElement(_gatsbyImage2.default, {
	            src: node.media.sizes.src,
	            style: {
	              margin: 0,
	              maxHeight: 250
	            },
	            sizes: node.media.sizes
	          })
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          node.description
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Button,
	          { as: _gatsbyLink2.default, to: "/blogue/" + node.slug + "/" },
	          "Lire l'article"
	        )
	      );
	    };
	
	    return _react2.default.createElement(
	      _semanticUiReact.Container,
	      null,
	      _react2.default.createElement(MetaTitle, null),
	      _react2.default.createElement(
	        "h1",
	        null,
	        "Blogue"
	      ),
	      _react2.default.createElement(
	        "section",
	        null,
	        frArticles.map(function (_ref2, i) {
	          var node = _ref2.node;
	          return _react2.default.createElement(ARTICLE, { node: node, key: node.id });
	        })
	      )
	    );
	  };
	
	  return BloguePage;
	}(_react2.default.Component);
	
	BloguePage.propTypes = propTypes;
	
	exports.default = BloguePage;
	var pageBlogueQuery = exports.pageBlogueQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blogue-js-27fbbaa0495bbe0b3e9c.js